export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "arrived": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Llegó"])},
          "in_preparation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Preparando"])},
          "in_transit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viajando"])}
        }
      },
      "en": {
        "labels": {
          "arrived": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Arrived"])},
          "in_preparation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Preparing"])},
          "in_transit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In transit"])}
        }
      }
    }
  })
}